document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".gift-coffee-de-method-option");
  const hiddenInput = document.getElementById("gift-coffee-de-method-input");
  const recipientFields = document.getElementById("recipientFields");

  flatpickr("#shipping_date", {
    dateFormat: "m/d/Y",
    minDate: new Date().fp_incr(1), // set minimum date to tomorrow
    disable: [
      date => (date.getDay() === 0 || date.getDay() === 6)  // disable weekends
    ]
  });

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((b) => b.classList.remove("selected"));
      button.classList.add("selected");
      hiddenInput.value = button.dataset.grind;
      if (button.dataset.grind?.toLowerCase() == "self") {
        recipientFields.style.display = "none";
      } else {
        recipientFields.style.display = "flex";
      }
    });
  });
});